/* Noor Kids · About page interactions (au-* sections)
   Scroll-driven, no dependencies. Loaded by several sections, runs once. */
(function () {
  if (window.NKAbout) return;
  window.NKAbout = true;
  document.documentElement.classList.add('nk-js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var updaters = new Map(); // section root -> update fn
  var ticking = false;

  function clamp(v) { return Math.min(1, Math.max(0, v)); }
  function vh() { return window.innerHeight || document.documentElement.clientHeight || 800; }

  // 0 at the moment a tall scroller's top hits the viewport top, 1 when its bottom reaches the viewport bottom.
  function stickyProgress(el) {
    var r = el.getBoundingClientRect();
    var total = r.height - vh();
    if (total <= 0) return r.top < 0 ? 1 : 0;
    return clamp(-r.top / total);
  }

  function scrollToProgress(el, p) {
    var r = el.getBoundingClientRect();
    var total = r.height - vh();
    var y = window.pageYOffset + r.top + Math.max(0, total) * p;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------- Pinning fix ----------
     position: sticky silently fails when any ancestor has overflow: hidden (many themes
     set it on the page wrapper to stop sideways scrolling). overflow: clip looks and clips
     the same but does not break sticky, so we swap it on those ancestors only. */
  var canClip = !!(window.CSS && CSS.supports && CSS.supports('overflow', 'clip'));
  function freeSticky(el) {
    var a = el.parentElement;
    while (a && a !== document.documentElement) {
      var cs = getComputedStyle(a);
      var fixX = cs.overflowX === 'hidden';
      var fixY = cs.overflowY === 'hidden';
      if (fixX || fixY) {
        if (canClip) {
          if (fixX) a.style.overflowX = 'clip';
          if (fixY) a.style.overflowY = 'clip';
        } else {
          // Older Safari: no overflow: clip. Drop the clipping so pinning still works.
          if (fixX) a.style.overflowX = 'visible';
          if (fixY) a.style.overflowY = 'visible';
        }
      }
      a = a.parentElement;
    }
  }

  /* ---------- Hero: photo eases in slightly as you scroll ---------- */
  function initHero(root) {
    var media = root.querySelector('[data-nk-hero-media]');
    var img = media && media.querySelector('.nk-img');
    if (!img || reduce) return null;
    return function () {
      var r = root.getBoundingClientRect();
      var p = clamp(-r.top / (r.height * 0.6));
      img.style.transform = 'scale(' + (1.08 - 0.08 * p).toFixed(4) + ')';
    };
  }

  /* ---------- Belief: statement lights up word by word ---------- */
  function initBelief(root) {
    var textEl = root.querySelector('[data-nk-words]');
    var scroller = root.querySelector('[data-nk-scroller]');
    if (!textEl || !scroller) return null;
    var target = (textEl.getAttribute('data-highlight') || '').toLowerCase().trim();
    var words = textEl.textContent.trim().split(/\s+/);
    var label = textEl.textContent.trim();
    textEl.textContent = '';
    textEl.setAttribute('aria-label', label);
    var spans = words.map(function (w, i) {
      var s = document.createElement('span');
      s.className = 'nk-word';
      s.setAttribute('aria-hidden', 'true');
      s.textContent = w;
      var bare = w.toLowerCase().replace(/[^\p{L}\p{N}'’-]/gu, '');
      s._hl = target && bare === target;
      if (s._hl) s.classList.add('nk-word--hl');
      textEl.appendChild(s);
      if (i < words.length - 1) textEl.appendChild(document.createTextNode(' '));
      return s;
    });
    function paint(p) {
      var n = spans.length;
      spans.forEach(function (s, i) {
        var lit = clamp(p * 1.25 * n - i);
        s.style.color = 'rgba(32, 38, 90, ' + (0.16 + 0.84 * lit).toFixed(3) + ')';
        if (s._hl) s.style.backgroundImage = 'linear-gradient(transparent 58%, rgba(244, 237, 123, ' + lit.toFixed(2) + ') 58%)';
      });
    }
    if (reduce) { paint(1); return null; }
    return function () { paint(stickyProgress(scroller)); };
  }

  /* ---------- Story: pinned photo follows the chapter being read ---------- */
  function initStory(root) {
    var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-nk-chapter]'));
    var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-nk-story-img]'));
    if (!chapters.length) return null;
    var current = -1;
    return function () {
      var active = 0;
      var line = vh() * 0.55;
      chapters.forEach(function (c, i) { if (c.getBoundingClientRect().top < line) active = i; });
      if (active === current) return;
      current = active;
      chapters.forEach(function (c, i) { c.classList.toggle('is-active', i === active); });
      imgs.forEach(function (im, i) { im.classList.toggle('is-active', i === active); });
    };
  }

  /* ---------- Numbers: count up once when they come into view ---------- */
  function format(n, commas) { return commas ? n.toLocaleString('en-US') : String(n); }
  function initStats(root) {
    var stats = Array.prototype.slice.call(root.querySelectorAll('[data-nk-stat]'));
    stats.forEach(function (stat) {
      var num = stat.querySelector('.nk-stat__num');
      if (!num) return;
      var target = parseInt(num.getAttribute('data-target'), 10) || 0;
      var suffix = num.getAttribute('data-suffix') || '';
      var commas = num.getAttribute('data-commas') === 'true';
      num.textContent = format(target, commas) + suffix;
      if (reduce) stat.classList.add('is-in');
    });
    if (reduce || !('IntersectionObserver' in window)) {
      stats.forEach(function (s) { s.classList.add('is-in'); });
      return null;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var stat = entry.target;
        var i = stats.indexOf(stat);
        var num = stat.querySelector('.nk-stat__num');
        var target = parseInt(num.getAttribute('data-target'), 10) || 0;
        var suffix = num.getAttribute('data-suffix') || '';
        var commas = num.getAttribute('data-commas') === 'true';
        setTimeout(function () {
          stat.classList.add('is-in');
          var t0 = performance.now();
          num.textContent = format(0, commas);
          (function frame(now) {
            var k = clamp((now - t0) / 1500);
            var e = 1 - Math.pow(1 - k, 3);
            num.textContent = format(Math.round(target * e), commas) + (k >= 1 ? suffix : '');
            if (k < 1) requestAnimationFrame(frame);
          })(t0);
        }, Math.max(0, i) * 140);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    stats.forEach(function (s) { io.observe(s); });
    root._nkCleanup = function () { io.disconnect(); };
    return null;
  }

  /* ---------- S.I.R.A.T.: one letter per screen, driven by scroll ---------- */
  function initSirat(root) {
    var scroller = root.querySelector('[data-nk-scroller]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-nk-panel]'));
    var rail = Array.prototype.slice.call(root.querySelectorAll('[data-nk-rail]'));
    if (!scroller || !panels.length) return null;
    var n = panels.length;
    root.classList.add('nk-js-ready');

    rail.forEach(function (btn, i) {
      btn.addEventListener('click', function () { scrollToProgress(scroller, Math.min(1, (i + 0.4) / n)); });
    });

    return function () {
      var p = stickyProgress(scroller);
      var x = p * n;
      var idx = Math.min(n - 1, Math.floor(x));
      var sub = p >= 1 ? 1 : x - idx;
      // Each letter arrives in steps: the word, then the explanation, then the research card
      // pops up like a sticker. Every bit of scroll reveals something.
      var first = idx === 0;
      var a1 = reduce || first ? 1 : clamp(sub / 0.12);
      var a2 = reduce ? 1 : clamp((sub - (first ? 0.02 : 0.1)) / 0.14);
      var a3 = reduce ? 1 : clamp((sub - (first ? 0.16 : 0.26)) / 0.16);
      var fout = reduce || idx === n - 1 ? 1 : clamp((1 - sub) / 0.12);

      panels.forEach(function (panel, i) {
        var on = i === idx;
        panel.classList.toggle('is-active', on);
        panel.style.opacity = on ? fout.toFixed(3) : '0';
        panel.style.transform = 'none';
        if (!panel._parts) {
          panel._parts = {
            letter: panel.querySelector('.nk-sirat__letter'),
            one: panel.querySelectorAll('[data-nk-part="1"]'),
            two: panel.querySelectorAll('[data-nk-part="2"]'),
            three: panel.querySelectorAll('[data-nk-part="3"]')
          };
        }
        var parts = panel._parts;
        var k1 = on ? a1 : 0, k2 = on ? a2 : 0, k3 = on ? a3 : 0;
        if (parts.letter) {
          parts.letter.style.opacity = k1.toFixed(3);
          parts.letter.style.transform = 'scale(' + (0.9 + 0.1 * k1).toFixed(4) + ')';
        }
        Array.prototype.forEach.call(parts.one, function (el) {
          el.style.opacity = k1.toFixed(3);
          el.style.transform = 'translateY(' + ((1 - k1) * 18).toFixed(1) + 'px)';
        });
        Array.prototype.forEach.call(parts.two, function (el) {
          el.style.opacity = k2.toFixed(3);
          el.style.transform = 'translateY(' + ((1 - k2) * 18).toFixed(1) + 'px)';
        });
        Array.prototype.forEach.call(parts.three, function (el) {
          el.style.opacity = k3.toFixed(3);
          el.style.transform = 'translateY(' + ((1 - k3) * 56).toFixed(1) + 'px) rotate(' + ((1 - k3) * -4).toFixed(2) + 'deg) scale(' + (0.94 + 0.06 * k3).toFixed(4) + ')';
        });
      });

      rail.forEach(function (btn, i) {
        var done = i < idx || (i === n - 1 && p >= 0.999);
        var active = i === idx && !done;
        btn.classList.toggle('is-done', done);
        btn.classList.toggle('is-active', active);
        if (i === idx) btn.setAttribute('aria-current', 'step'); else btn.removeAttribute('aria-current');
        var fill = btn.querySelector('[data-nk-fill]');
        if (fill) fill.style.width = (clamp(x - i) * 100).toFixed(1) + '%';
      });
    };
  }

  /* ---------- Characters: drift against the scroll (brand kit Character component) ----------
     About 0.12 x distance from screen centre x strength/5, capped at data-max (and data-min for peeks). */
  function initChar(el) {
    if (reduce) return null;
    return function () {
      var vh = window.innerHeight;
      var r = el.getBoundingClientRect(), cur = el._nkY || 0;
      var max = Number(el.getAttribute('data-max')) || 40;
      var min = el.hasAttribute('data-min') ? Number(el.getAttribute('data-min')) : -max;
      var strength = Number(el.getAttribute('data-nk-char')) || 0;
      var mid = r.top - cur + r.height / 2;
      var ref = Math.min(vh / 2, mid + window.pageYOffset);
      var y = Math.max(min, Math.min(max, (mid - ref) * 0.12 * (strength / 5)));
      el._nkY = y;
      el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    };
  }


  /* ---------- Mission: each sentence rises in whole once it reaches the lower part of the screen ---------- */
  function initMission(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-nk-step]'));
    if (!steps.length) return null;
    if (reduce) { steps.forEach(function (s) { s.classList.add('is-in'); }); return null; }
    return function () {
      var line = vh() * 0.8;
      steps.forEach(function (s) { if (!s.classList.contains('is-in') && s.getBoundingClientRect().top < line) s.classList.add('is-in'); });
    };
  }

  /* ---------- Values: desktop pins the section and lights one value per stretch of scroll;
     phones light the value nearest the middle of the screen ---------- */
  function initValues(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-nk-value]'));
    var track = root.querySelector('.nk-values__track');
    if (!items.length) return null;
    if (reduce) { items.forEach(function (i) { i.classList.add('is-active'); }); return null; }
    var desk = window.matchMedia('(min-width: 900px)');
    var cur = -1;
    function set(k) {
      if (k === cur) return; cur = k;
      items.forEach(function (i, n) { i.classList.toggle('is-active', n === k); });
    }
    return function () {
      if (desk.matches && track) {
        var r = track.getBoundingClientRect(), pin = track.firstElementChild.getBoundingClientRect();
        var total = r.height - pin.height;
        if (total <= 0) { set(0); return; }
        var p = clamp((pin.top - r.top) / total);
        set(Math.min(items.length - 1, Math.floor(p * items.length)));
      } else {
        var mid = vh() / 2, best = 0, bd = Infinity;
        items.forEach(function (i, n) { var b = i.getBoundingClientRect(), d = Math.abs(b.top + b.height / 2 - mid); if (d < bd) { bd = d; best = n; } });
        set(best);
      }
    };
  }

  var inits = { hero: initHero, belief: initBelief, story: initStory, stats: initStats, sirat: initSirat, mission: initMission, values: initValues };

  function mount(scope) {
    var roots = (scope || document).querySelectorAll('[data-nk]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root._nkMounted) return;
      root._nkMounted = true;
      var kind = root.getAttribute('data-nk');
      if (kind === 'belief' || kind === 'story' || kind === 'sirat' || kind === 'values') freeSticky(root);
      var fn = inits[kind];
      var update = fn ? fn(root) : null;
      if (update) { updaters.set(root, update); update(); }
      Array.prototype.forEach.call(root.querySelectorAll('[data-nk-char]'), function (el) {
        var u = initChar(el);
        if (u) { updaters.set(el, u); u(); }
      });
    });
  }

  function unmount(scope) {
    var roots = (scope || document).querySelectorAll('[data-nk]');
    Array.prototype.forEach.call(roots, function (root) {
      updaters.delete(root);
      Array.prototype.forEach.call(root.querySelectorAll('[data-nk-char]'), function (el) { updaters.delete(el); });
      if (root._nkCleanup) root._nkCleanup();
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      updaters.forEach(function (update, root) {
        if (!root.isConnected) { updaters.delete(root); return; }
        update();
      });
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); onScroll(); });
  document.addEventListener('shopify:section:unload', function (e) { unmount(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(); });
  } else {
    mount();
  }
})();
